import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useState } from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { showCRMSuccessToast } from '@flowwai-frontend/shared-web/common/ui'
import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import {
   UserPINOTPController,
   UserPINUpdateMode
} from '@flowwai-frontend/shared-web/iam/ui'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { UserModel } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import UserPINInputController from '../UserPINInputController/UserPINInputController'

interface Props {
   userDetails: UserModel
   mode: UserPINUpdateMode
   onCloseModal: () => void
   onUpdatePIN: (userPIN: UserPIN) => void
}

const UserPINUpdateController = (props: Props): React.ReactElement => {
   const { userDetails, mode } = props

   const [isOTPVerified, setIsOTPVerified] = useState(false)

   const t = useCustomT('iam:userPIN:pinUpdate')

   const { theme } = useAppTheme()
   const themes = theme.iam.userPIN

   const onOtpSubmissionSuccess = () => {
      setIsOTPVerified(true)
   }

   const onPINUpdateSuccess = (userPIN: UserPIN) => {
      const isResetPIN = mode === 'RESET_PIN'
      showCRMSuccessToast(
         isResetPIN ? t('pinResetSuccess') : t('pinSetSuccess')
      )
      props.onUpdatePIN(userPIN)
      props.onCloseModal()
   }

   const renderUIBasedOnState = () =>
      isOTPVerified ? (
         <UserPINInputController
            mode={mode}
            onPINUpdateSuccess={onPINUpdateSuccess}
            onCancel={props.onCloseModal}
         />
      ) : (
         <UserPINOTPController
            mode={mode}
            userDetails={userDetails}
            onOtpSubmissionSuccess={onOtpSubmissionSuccess}
            containerClassName={'p-8'}
         />
      )

   return (
      <div
         className={cn(
            'rounded-2xl border',
            themes.containerBgColor,
            themes.containerBorderColor
         )}
      >
         {renderUIBasedOnState()}
      </div>
   )
}

export default observer(UserPINUpdateController)
